import type React from 'react';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import { FrontHeaderCompactLayout, FrontHeaderTopLayout } from '#theme';
import { MainMenu } from '../../../routes/menu/MainMenu.tsx';
import { RightMenu } from '../../../routes/menu/RightMenu.tsx';

export interface PageLayoutHeaderProps {
  boxed?: boolean;
  fixed?: boolean;
  extra?: React.ReactNode;
  /** Solo la fascia del menu con logo e menu destro compatto (layout fullscreen) */
  compact?: boolean;
}

/**
 * Fascia in alto della pagina che contiene il logo,
 * il menu principale, il menu delle notifiche e quello dell'utente
 */
export function PageLayoutHeader(props: PageLayoutHeaderProps) {
  const { boxed, extra, compact } = props;
  const isMobile = useBreakpoint(down('md'));

  if (compact) {
    return (
      <FrontHeaderCompactLayout
        right={<RightMenu extra={extra} isMobile={isMobile} compact />}
        main={!isMobile && <MainMenu />}
        isMobile={isMobile}
      />
    );
  }

  return (
    <FrontHeaderTopLayout
      boxed={boxed}
      right={<RightMenu extra={extra} isMobile={isMobile} />}
      main={!isMobile && <MainMenu />}
      isMobile={isMobile}
    />
  );
}
